import React, { useState } from 'react';
import { FadeIn } from './ui';
import { Check } from 'lucide-react';
type OptionId = 'primaria' | 'pack-completo';
interface CheckoutOption {
  id: OptionId;
  title: string;
  icon: string;
  subtitle: string;
  oldPrice: string;
  newPrice: string;
  badges?: {
    text: string;
    type: 'primary' | 'secondary';
  }[];
  ctaText: string;
  ctaSubtext: string;
  url: string;
  features: string[];
}
const options: CheckoutOption[] = [{
  id: 'primaria',
  title: 'Sistema Base',
  icon: '📘',
  subtitle: '6 tomos + 6 Bonos',
  oldPrice: '$39.900',
  newPrice: '$19.990',
  ctaText: 'SÍ, QUIERO SISTEMA BASE →',
  ctaSubtext: 'Ideal para docentes de nivel primario',
  url: 'https://profelisto.com.ar/checkouts/cn/hWNBbWBBuPtR7PmmhGLmMEAk/es-ar?_r=AQABhCozGeJpKfIo6Q_lyWnmdh6WBRiDoew2JdGEzcJTsM0',
  features: ['6 Tomos completos', 'Rúbricas incluidas', '6 Bonos estratégicos', 'Acceso inmediato PDF']
}, {
  id: 'pack-completo',
  title: 'PACK COMPLETO',
  icon: '🏆',
  subtitle: '6 tomos + 6 Bonos + 2 Bonus Exclusivos',
  oldPrice: '$59.990',
  newPrice: '$29.990',
  badges: [{
    text: '⭐ MÁS ELEGIDO',
    type: 'primary'
  }, {
    text: 'AHORRÁS $30.000',
    type: 'secondary'
  }],
  ctaText: 'SÍ, QUIERO PACK COMPLETO →',
  ctaSubtext: 'La opción más elegida por docentes que enseñan en los dos niveles',
  url: 'https://profelisto.com.ar/checkouts/cn/hWNBbWicewZA0y3gQvVv5TaE/es-ar?_r=AQABZQL9AtK56dsCNAB_H07kskdFZcmY9BxTCkhaeZCyqrQ',
  features: ['6 Tomos completos', '6 Bonos estratégicos', 'Comunicación con Padres Difíciles', 'Autoridad y Posicionamiento Docente', 'Rúbricas incluidas', 'Acceso inmediato PDF']
}];
export function CheckoutSection() {
  const [selectedId, setSelectedId] = useState<OptionId>('pack-completo');
  const selectedOption = options.find(o => o.id === selectedId)!;
  return <section id="pricing" className="py-5 md:py-[100px] px-4 md:px-4 bg-white" data-id="element-49">
      <div className="max-w-[680px] mx-auto w-full" data-id="element-50">
        <FadeIn data-id="element-51">
          <div className="space-y-2.5 md:space-y-4 mb-4 md:mb-6" data-id="element-52">
            {options.map(option => {
            const isSelected = selectedId === option.id;
            return <div key={option.id} onClick={() => setSelectedId(option.id)} className={`relative cursor-pointer rounded-xl md:rounded-2xl p-3 md:p-6 transition-all duration-300 border-2 ${isSelected ? 'bg-brand-green/5 border-brand-green shadow-[0_0_15px_rgba(5,150,105,0.1)]' : 'bg-gray-50 border-gray-200 hover:border-gray-300'}`} data-id="element-53">
                  <div className="flex items-center gap-3 md:gap-4" data-id="element-54">
                    {/* Radio */}
                    <div className="shrink-0" data-id="element-55">
                      <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-green' : 'border-gray-400'}`} data-id="element-56">
                        {isSelected && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-green" data-id="element-57" />}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 flex items-center justify-between gap-2 md:gap-4" data-id="element-58">
                      <div className="min-w-0" data-id="element-59">
                        <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-60">
                          <span className="text-lg md:text-xl" data-id="element-61">
                            {option.icon}
                          </span>
                          <h3 className="text-base md:text-xl font-bold text-gray-900" data-id="element-62">
                            {option.title}
                          </h3>
                        </div>
                        {option.badges && <div className="flex gap-1.5 md:gap-2 mb-0.5" data-id="element-63">
                            {option.badges.map((badge, i) => <span key={i} className={`text-[9px] md:text-xs font-bold px-1.5 md:px-2 py-0.5 rounded-full ${badge.type === 'primary' ? 'bg-brand-gold text-white' : 'bg-brand-green/10 text-brand-green'}`} data-id="element-64">
                                {badge.text}
                              </span>)}
                          </div>}
                        <p className="text-gray-500 text-xs md:text-sm" data-id="element-65">
                          {option.subtitle}
                        </p>
                      </div>

                      <div className="text-right shrink-0" data-id="element-66">
                        <div className="text-gray-400 text-xs md:text-sm line-through decoration-gray-400" data-id="element-67">
                          {option.oldPrice}
                        </div>
                        <div className={`text-xl md:text-3xl font-black ${isSelected ? 'text-brand-green' : 'text-gray-900'}`} data-id="element-68">
                          {option.newPrice}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          <a href={selectedOption.url} className="block w-full bg-brand-green hover:bg-brand-greenHover text-white text-center font-black rounded-xl py-3.5 md:py-5 px-6 text-base md:text-xl transition-all duration-300 shadow-[0_0_20px_rgba(5,150,105,0.25)] hover:shadow-[0_0_30px_rgba(5,150,105,0.4)] md:hover:-translate-y-1 active:scale-[0.98] mb-2 md:mb-3" data-id="element-69">
            {selectedOption.ctaText}
          </a>

          <p className="text-gray-500 text-center text-xs md:text-sm italic mb-3 md:mb-8" data-id="element-70">
            {selectedOption.ctaSubtext}
          </p>

          {/* Features box - hidden on mobile to save space */}
          <div className="hidden md:block bg-gray-50 border border-gray-200 rounded-xl md:rounded-2xl p-5 md:p-8 mb-8" data-id="element-71">
            <h4 className="text-gray-500 text-xs md:text-sm font-bold tracking-widest uppercase mb-4 md:mb-6" data-id="element-72">
              {selectedOption.title} INCLUYE:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 md:gap-y-4 gap-x-6" data-id="element-73">
              {selectedOption.features.map((feature, i) => <div key={i} className="flex items-start gap-2" data-id="element-74">
                  <Check size={18} className="text-brand-green shrink-0 mt-0.5" data-id="element-75" />
                  <span className="text-gray-700 text-sm md:text-base" data-id="element-76">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-gray-500 font-medium" data-id="element-77">
            <div className="flex items-center gap-1" data-id="element-78">
              <span data-id="element-79">🔒</span> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-80">
              <span data-id="element-81">⚡</span> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1" data-id="element-82">
              <span data-id="element-83">🛡️</span> Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-84">
              <span data-id="element-85">💳</span> Mercado Pago
            </div>
          </div>

          {selectedId === 'pack-completo' && <div className="mt-6 md:mt-10 space-y-3 md:space-y-5" data-id="element-86">
              <h3 className="text-xl md:text-2xl font-black text-brand-green text-center mb-6" data-id="element-87">
                Exclusivos del Pack Completo:
              </h3>

              <div className="bg-gray-50 border border-brand-gold/40 rounded-2xl p-6 md:p-8" data-id="element-88">
                <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-gold text-xs font-bold px-3 py-1.5 rounded-full mb-3 border border-brand-gold/20" data-id="element-89">
                  ⭐ EXCLUSIVO PACK COMPLETO
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-1" data-id="element-90">
                  Comunicación con Padres Difíciles
                </h4>
                <p className="text-sm text-brand-green font-semibold mb-2" data-id="element-91">
                  Qué decir, cómo responder y cómo sostener tu autoridad en cada
                  conversación difícil.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-92">
                  Emails, frases y protocolos listos para manejar reclamos,
                  reuniones y mensajes conflictivos con claridad y seguridad.
                </p>
              </div>

              <div className="bg-gray-50 border border-brand-gold/40 rounded-2xl p-6 md:p-8" data-id="element-93">
                <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-gold text-xs font-bold px-3 py-1.5 rounded-full mb-3 border border-brand-gold/20" data-id="element-94">
                  ⭐ EXCLUSIVO PACK COMPLETO
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-1" data-id="element-95">
                  Autoridad y Posicionamiento Docente
                </h4>
                <p className="text-sm text-brand-green font-semibold mb-2" data-id="element-96">
                  Cómo hacer que tu trabajo se note, gane valor y te dé más
                  respaldo dentro de la institución.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-97">
                  Un sistema simple para fortalecer tu imagen profesional,
                  comunicar mejor lo que hacés y dejar de ser un docente
                  invisible.
                </p>
              </div>
            </div>}
        </FadeIn>
      </div>
    </section>;
}